module.exports = __webpack_public_path__ + "img/motorcycle-grey.7b6078b9.svg";